import React, { JSX } from 'react';
import { Button, InputText } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { FormInputNameCheckEmail } from '../types';

interface StateProps {
  state: boolean;
  sendCodeEmail: boolean;
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
  onSendConfirmEmail: () => void;
}

type Props = StateProps & DispatchProps;

export const CheckEmailContent: React.FC<Props> = ({
  sendCodeEmail,
  formData,
  formErrors,
  onChangeFormInput,
  onSendConfirmEmail,
  state,
}): JSX.Element => (
  <div>
    <div className="mt-8 w-full">
      <form onSubmit={e => e.preventDefault()}>
        <div className="mb-[20px]">
          <InputText
            name="cpf"
            label="CPF"
            placeholder="123.456.789-00"
            className={`appearance-none w-full
                        rounded-md text-heading leading-tight focus:outline-none
                        focus:shadow-outline text-xs font-dmsans font-normal`}
            maxLength={14}
            value={formData[FormInputNameCheckEmail.cpf]}
            onChange={e => onChangeFormInput(FormInputNameCheckEmail.cpf)(e.target.value)}
            error={formErrors.cpf && formErrors.cpf[0]}
          />
        </div>
        {sendCodeEmail ? (
          <div className="mb-[20px]">
            <InputText
              name="email"
              label="E-mail"
              placeholder="meuemail@email.com"
              className={`appearance-none w-full
                rounded-md text-heading leading-tight focus:outline-none
                focus:shadow-outline text-xs font-dmsans font-normal`}
              value={formData[FormInputNameCheckEmail.email]}
              onChange={e => onChangeFormInput(FormInputNameCheckEmail.email)(e.target.value)}
              error={formErrors.email && formErrors.email[0]}
            />
          </div>
        ) : (
          <div className="mb-[20px]">
            <InputText
              name="phone"
              label="Numero Whatsapp"
              placeholder="(61) 9 9999-9999"
              className={`appearance-none w-full
                rounded-md text-heading leading-tight focus:outline-none
                focus:shadow-outline text-xs font-dmsans font-normal`}
              value={formData[FormInputNameCheckEmail.phone]}
              onChange={e => onChangeFormInput(FormInputNameCheckEmail.phone)(e.target.value)}
              error={formErrors.phone && formErrors.phone[0]}
            />
          </div>
        )}

        <div
          className="mb-[20px] flex flex-col items-start justify-between"
          id="termsAndConditions"
        >
          <Button
            type="button"
            title="Confirmar e-mail"
            buttonStyle="primary"
            size="xlg"
            className="w-full"
            onClick={onSendConfirmEmail}
            disabled={formData[FormInputNameCheckEmail.cpf] === '' || state}
          />
        </div>
      </form>
    </div>
  </div>
);
